var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "boss-main-container" }, [
    _c(
      "div",
      { staticClass: "boss-main-content-wrap" },
      [
        _c("setting-header", {
          attrs: {
            breadcrumbs: [{ name: "各種設定" }],
            title: "応募者管理＿選考フェーズ・ステータス設定",
          },
        }),
        _vm._v(" "),
        _c("section", [
          _c("h3", { staticClass: "boss-joboffer-title boss-setting" }, [
            _vm._v("\n        選考フェーズの設定\n      "),
          ]),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "boss-phase-preview-container" }, [
            _c("div", { staticClass: "boss-phase-preview" }, [
              _c("p", { staticClass: "boss-phase-preview-text" }, [
                _vm._v("\n            選考フェーズのプレビュー\n          "),
              ]),
              _vm._v(" "),
              _c(
                "ul",
                {
                  staticClass: "clearfix boss-phase-preview-list",
                  class: [
                    _vm.selectedPhases && _vm.selectedPhases.length > 5
                      ? "boss-phase-preview-list-wrap"
                      : "",
                  ],
                },
                _vm._l(_vm.selectedPhases, function (phase, i) {
                  return _c(
                    "li",
                    { key: i, staticClass: "boss-phase-preview-item" },
                    [
                      _c(
                        "span",
                        { staticClass: "boss-phase-preview-item-text" },
                        [_vm._v(_vm._s(phase.name))]
                      ),
                    ]
                  )
                }),
                0
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "boss-selection-container" }, [
            _c(
              "div",
              {
                staticClass:
                  "boss-select-container boss-left boss-select-balloon",
              },
              [
                _vm._m(1),
                _vm._v(" "),
                _c("div", { staticClass: "boss-select-wrap" }, [
                  _c(
                    "ul",
                    {
                      staticClass: "boss-select-list-phase pega-clear-padding",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "pega-drag-area min-height-0 padding-bottom-0",
                        },
                        [
                          _vm.entryPhase
                            ? _c(
                                "li",
                                {
                                  staticClass:
                                    "boss-select-item boss-no-move pega-no-move",
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "boss-select-item-text",
                                      attrs: { "data-test": "phase-entry" },
                                    },
                                    [_vm._v(_vm._s(_vm.entryPhase.name))]
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.isDraggingPhase
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "boss-select-item pega-drop-area margin-bottom-1 border-none-side",
                              attrs: { "data-test": "drop-area-phase" },
                            },
                            [
                              _c("p", [
                                _vm._v(
                                  "↓ この範囲に要素をドラッグしてください"
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "draggable",
                        {
                          staticClass:
                            "pega-drag-area padding-top-0 min-height-phase-setting",
                          attrs: {
                            move: _vm.move,
                            group: "unselectedPhases",
                            "data-test": "draggable-selected-phase",
                          },
                          on: {
                            change: _vm.changePhase,
                            start: _vm.changeDraggingPhase,
                            end: _vm.changeDraggingPhase,
                          },
                          model: {
                            value: _vm.selectedPhases,
                            callback: function ($$v) {
                              _vm.selectedPhases = $$v
                            },
                            expression: "selectedPhases",
                          },
                        },
                        [
                          _vm._l(_vm.selectedPhases, function (phase, i) {
                            return [
                              !phase.isEntryPhase
                                ? _c(
                                    "li",
                                    {
                                      key: i,
                                      staticClass: "boss-select-item boss-any",
                                      class: {
                                        "boss-no-move": phase.isRequired,
                                      },
                                      staticStyle: { display: "block" },
                                      attrs: {
                                        "data-test": "selected-phase-" + i,
                                      },
                                    },
                                    [
                                      !phase.isEditing
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "boss-select-item-text",
                                              attrs: {
                                                "data-test":
                                                  "selected-phase-name-" + i,
                                              },
                                            },
                                            [_vm._v(_vm._s(phase.name))]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      phase.isEditing
                                        ? _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: phase.editName,
                                                expression: "phase.editName",
                                              },
                                            ],
                                            ref: "selected-phase-" + i,
                                            refInFor: true,
                                            staticClass: "pega-select-input",
                                            class: {
                                              "is-invalid-input":
                                                phase.isInvalidName,
                                            },
                                            attrs: {
                                              "data-test":
                                                "selected-phase-name-edit-" + i,
                                              "max-length": "5",
                                              type: "text",
                                            },
                                            domProps: { value: phase.editName },
                                            on: {
                                              keypress: function ($event) {
                                                return _vm.finishEdit(
                                                  $event,
                                                  phase
                                                )
                                              },
                                              keyup: function ($event) {
                                                return _vm.checkInvalidName(
                                                  phase
                                                )
                                              },
                                              blur: function ($event) {
                                                return _vm.finishEdit(
                                                  $event,
                                                  phase
                                                )
                                              },
                                              input: function ($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  phase,
                                                  "editName",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !phase.isRequired && !phase.isEditing
                                        ? _c(
                                            "span",
                                            {
                                              staticClass: "boss-any-text",
                                              attrs: {
                                                "data-test":
                                                  "selected-phase-any-" + i,
                                              },
                                            },
                                            [_vm._v("任意")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      phase.isDeletable && !phase.isEditing
                                        ? _c("span", {
                                            staticClass:
                                              "boss-icon-pencil pega-selected",
                                            attrs: {
                                              "data-test":
                                                "selected-phase-edit-" + i,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.goEdit(
                                                  phase,
                                                  "selected-phase-" + i
                                                )
                                              },
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      phase.isInvalidName
                                        ? _c("validation-label", {
                                            attrs: {
                                              "data-test":
                                                "selected-phase-error-" + i,
                                              label: phase.error,
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]
                          }),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm.isDraggingPhase
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "boss-select-item pega-drop-area border-none-side",
                              attrs: { "data-test": "drop-area-phase" },
                            },
                            [
                              _c("p", [
                                _vm._v(
                                  "↑ この範囲に要素をドラッグしてください"
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _vm._m(2),
            _vm._v(" "),
            _c("div", { staticClass: "boss-select-container boss-right" }, [
              _vm._m(3),
              _vm._v(" "),
              _c("div", { staticClass: "boss-select-setting" }, [
                _c(
                  "div",
                  { staticClass: "boss-select-input-container" },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.addPhaseName,
                          expression: "addPhaseName",
                        },
                      ],
                      staticClass: "boss-select-input",
                      class: { "is-invalid-input": _vm.isOverPhaseNameLength },
                      attrs: {
                        type: "text",
                        placeholder: "選考フェーズ名の新規作成",
                        "data-test": "new-phase",
                      },
                      domProps: { value: _vm.addPhaseName },
                      on: {
                        keypress: _vm.addPhase,
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.addPhaseName = $event.target.value
                        },
                      },
                    }),
                    _vm._v(" "),
                    _vm.isOverPhaseNameLength
                      ? _c("validation-label", {
                          attrs: {
                            "data-test": "is-over-phase-name-length",
                            label:
                              "選考フェーズ名は5文字以内で入力してください",
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._m(4),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "boss-select-wrap pega-clear-padding display-phase-setting-right-height",
                  },
                  [
                    _c(
                      "ul",
                      { staticClass: "boss-select-list border-none" },
                      [
                        _vm.isDraggingPhase && !_vm.isDraggingPhaseRequired
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "boss-select-item pega-drop-area border-none-side",
                                attrs: {
                                  "data-test": "drop-area-phase-unselected",
                                },
                              },
                              [
                                _c("p", [
                                  _vm._v(
                                    "↓ この範囲に要素をドラッグしてください"
                                  ),
                                ]),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "draggable",
                          {
                            staticClass:
                              "pega-drag-area min-height-phase-no-setting",
                            attrs: {
                              id: "unselected",
                              group: "unselectedPhases",
                              "data-test": "draggable-unselected-phase",
                            },
                            on: {
                              start: _vm.changeDraggingPhase,
                              end: _vm.changeDraggingPhase,
                            },
                            model: {
                              value: _vm.unselectedPhases,
                              callback: function ($$v) {
                                _vm.unselectedPhases = $$v
                              },
                              expression: "unselectedPhases",
                            },
                          },
                          _vm._l(_vm.unselectedPhases, function (phase, i) {
                            return _c(
                              "li",
                              {
                                key: i,
                                staticClass: "boss-select-item boss-any",
                                staticStyle: { display: "block" },
                                attrs: { "data-test": "unselected-phase-" + i },
                              },
                              [
                                !phase.isEditing
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "boss-select-item-text",
                                        attrs: {
                                          "data-test":
                                            "unselected-phase-name-" + i,
                                        },
                                      },
                                      [_vm._v(_vm._s(phase.name))]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                phase.isEditing
                                  ? _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: phase.editName,
                                          expression: "phase.editName",
                                        },
                                      ],
                                      ref: "unselected-phase-" + i,
                                      refInFor: true,
                                      staticClass: "pega-select-input",
                                      class: {
                                        "is-invalid-input": phase.isInvalidName,
                                      },
                                      attrs: {
                                        "max-length": "5",
                                        type: "text",
                                        "data-test":
                                          "unselected-phase-name-edit-" + i,
                                      },
                                      domProps: { value: phase.editName },
                                      on: {
                                        keypress: function ($event) {
                                          return _vm.finishEdit($event, phase)
                                        },
                                        keyup: function ($event) {
                                          return _vm.checkInvalidName(phase)
                                        },
                                        blur: function ($event) {
                                          return _vm.finishEdit($event, phase)
                                        },
                                        input: function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            phase,
                                            "editName",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                !phase.isEditing
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "boss-any-text",
                                        attrs: {
                                          "data-test":
                                            "unselected-phase-any-" + i,
                                        },
                                      },
                                      [_vm._v("任意")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                phase.isDeletable && !phase.isEditing
                                  ? _c("span", {
                                      staticClass: "boss-icon-trash",
                                      attrs: {
                                        "data-test":
                                          "unselected-phase-reset-" + i,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.removePhase(phase)
                                        },
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                phase.isDeletable && !phase.isEditing
                                  ? _c("span", {
                                      staticClass: "boss-icon-pencil",
                                      attrs: {
                                        "data-test":
                                          "unselected-phase-edit-" + i,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.goEdit(
                                            phase,
                                            "unselected-phase-" + i
                                          )
                                        },
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                phase.isInvalidName
                                  ? _c("validation-label", {
                                      attrs: {
                                        "data-test":
                                          "unselected-phase-error-" + i,
                                        label: phase.error,
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _vm.isDraggingPhase && !_vm.isDraggingPhaseRequired
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "boss-select-item pega-drop-area border-none-side",
                                attrs: {
                                  "data-test": "drop-area-phase-unselected",
                                },
                              },
                              [
                                _c("p", [
                                  _vm._v(
                                    "↑ この範囲に要素をドラッグしてください"
                                  ),
                                ]),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "boss-button-container" }, [
            _c(
              "button",
              {
                staticClass: "boss-button-default pega-button",
                attrs: {
                  "data-test": "phase-update",
                  disabled: _vm.hasEditingPhases,
                },
                on: { click: _vm.registerPhases },
              },
              [_vm._v("\n          選考フェーズを更新する\n        ")]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("section", [
          _c("h3", { staticClass: "boss-joboffer-title boss-setting" }, [
            _vm._v("\n        選考ステータスの設定\n      "),
          ]),
          _vm._v(" "),
          _vm._m(5),
          _vm._v(" "),
          _c("div", { staticClass: "boss-selection-container boss-status" }, [
            _c("div", { staticClass: "boss-select-container boss-left" }, [
              _vm._m(6),
              _vm._v(" "),
              _c("div", { staticClass: "boss-select-wrap" }, [
                _c(
                  "ul",
                  { staticClass: "boss-select-list-phase pega-clear-padding" },
                  [
                    _vm.isDraggingStatus
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "boss-select-item pega-drop-area border-none-side",
                            attrs: { "data-test": "drop-area-status" },
                          },
                          [
                            _c("p", [
                              _vm._v("↓ この範囲に要素をドラッグしてください"),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "draggable",
                      {
                        class: [
                          "pega-drag-area padding-bottom-0",
                          {
                            "min-height-status-setting": _vm.isDraggingStatus,
                            "min-height-auto": !_vm.isDraggingStatus,
                          },
                        ],
                        attrs: {
                          group: "status",
                          "data-test": "draggable-selected-status",
                        },
                        on: {
                          change: _vm.changeStatus,
                          start: _vm.changeDraggingStatus,
                          end: _vm.changeDraggingStatus,
                        },
                        model: {
                          value: _vm.selectedStatuses,
                          callback: function ($$v) {
                            _vm.selectedStatuses = $$v
                          },
                          expression: "selectedStatuses",
                        },
                      },
                      [
                        _vm._l(_vm.selectedStatuses, function (status, i) {
                          return [
                            !status.isRequired
                              ? _c(
                                  "li",
                                  {
                                    key: i,
                                    staticClass: "boss-select-item boss-any",
                                    staticStyle: { display: "block" },
                                    attrs: {
                                      "data-test": "selected-status-" + i,
                                    },
                                  },
                                  [
                                    !status.isEditing
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "boss-select-item-text",
                                            attrs: {
                                              "data-test":
                                                "selected-status-name-" + i,
                                            },
                                          },
                                          [_vm._v(_vm._s(status.name))]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    status.isEditing
                                      ? _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: status.editName,
                                              expression: "status.editName",
                                            },
                                          ],
                                          ref: "selected-status-" + i,
                                          refInFor: true,
                                          staticClass: "pega-select-input",
                                          class: {
                                            "is-invalid-input":
                                              status.isInvalidName,
                                          },
                                          attrs: {
                                            "max-length": "5",
                                            type: "text",
                                            "data-test":
                                              "selected-status-name-edit-" + i,
                                          },
                                          domProps: { value: status.editName },
                                          on: {
                                            keypress: function ($event) {
                                              return _vm.finishEdit(
                                                $event,
                                                status
                                              )
                                            },
                                            keyup: function ($event) {
                                              return _vm.checkInvalidName(
                                                status
                                              )
                                            },
                                            blur: function ($event) {
                                              return _vm.finishEdit(
                                                $event,
                                                status
                                              )
                                            },
                                            input: function ($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                status,
                                                "editName",
                                                $event.target.value
                                              )
                                            },
                                          },
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !status.isEditing
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "boss-any-text",
                                            attrs: {
                                              "data-test":
                                                "selected-status-any-" + i,
                                            },
                                          },
                                          [_vm._v("任意")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    status.isDeletable && !status.isEditing
                                      ? _c("span", {
                                          staticClass:
                                            "boss-icon-pencil pega-selected",
                                          attrs: {
                                            "data-test":
                                              "selected-status-edit-" + i,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.goEdit(
                                                status,
                                                "selected-status-" + i
                                              )
                                            },
                                          },
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    status.isInvalidName
                                      ? _c("validation-label", {
                                          attrs: {
                                            "data-test":
                                              "selected-status-error-" + i,
                                            label: status.error,
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _vm.isDraggingStatus
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "boss-select-item pega-drop-area border-none-side margin-top-1",
                            attrs: { "data-test": "drop-area-status" },
                          },
                          [
                            _c("p", [
                              _vm._v("↑ この範囲に要素をドラッグしてください"),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "pega-drag-area min-height-0 padding-top-0",
                      },
                      _vm._l(_vm.requiredStatuses, function (status, i) {
                        return _c(
                          "li",
                          {
                            key: i,
                            staticClass:
                              "boss-select-item boss-no-move pega-no-move",
                            attrs: {
                              "data-test": "selected-required-status-" + i,
                            },
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "boss-select-item-text",
                                attrs: {
                                  "data-test":
                                    "selected-required-status-name-" + i,
                                },
                              },
                              [_vm._v(_vm._s(status.name))]
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _vm._m(7),
            _vm._v(" "),
            _c("div", { staticClass: "boss-select-container boss-right" }, [
              _vm._m(8),
              _vm._v(" "),
              _c("div", { staticClass: "boss-select-setting" }, [
                _c(
                  "div",
                  { staticClass: "boss-select-input-container" },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.addStatusName,
                          expression: "addStatusName",
                        },
                      ],
                      staticClass: "boss-select-input",
                      class: { "is-invalid-input": _vm.isOverStatusNameLength },
                      attrs: {
                        type: "text",
                        placeholder: "選考ステータスの新規作成",
                        "data-test": "new-status",
                      },
                      domProps: { value: _vm.addStatusName },
                      on: {
                        keypress: _vm.addStatus,
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.addStatusName = $event.target.value
                        },
                      },
                    }),
                    _vm._v(" "),
                    _vm.isOverStatusNameLength
                      ? _c("validation-label", {
                          attrs: {
                            "data-test": "is-over-status-name-length",
                            label:
                              "選考ステータス名は5文字以内で入力してください",
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._m(9),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "boss-select-wrap pega-clear-padding display-phase-setting-right-height",
                  },
                  [
                    _c(
                      "ul",
                      { staticClass: "boss-select-list border-none" },
                      [
                        _vm.isDraggingStatus
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "boss-select-item pega-drop-area border-none-side",
                                attrs: { "data-test": "drop-area-status" },
                              },
                              [
                                _c("p", [
                                  _vm._v(
                                    "↓ この範囲に要素をドラッグしてください"
                                  ),
                                ]),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "draggable",
                          {
                            staticClass:
                              "pega-drag-area min-height-status-no-setting",
                            attrs: {
                              id: "unselected",
                              group: "status",
                              "data-test": "draggable-unselected-status",
                            },
                            on: {
                              start: _vm.changeDraggingStatus,
                              end: _vm.changeDraggingStatus,
                            },
                            model: {
                              value: _vm.unselectedStatuses,
                              callback: function ($$v) {
                                _vm.unselectedStatuses = $$v
                              },
                              expression: "unselectedStatuses",
                            },
                          },
                          _vm._l(_vm.unselectedStatuses, function (status, i) {
                            return _c(
                              "li",
                              {
                                key: i,
                                staticClass: "boss-select-item boss-any",
                                staticStyle: { display: "block" },
                                attrs: {
                                  "data-test": "unselected-status-" + i,
                                },
                              },
                              [
                                !status.isEditing
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "boss-select-item-text",
                                        attrs: {
                                          "data-test":
                                            "unselected-status-name-" + i,
                                        },
                                      },
                                      [_vm._v(_vm._s(status.name))]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                status.isEditing
                                  ? _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: status.editName,
                                          expression: "status.editName",
                                        },
                                      ],
                                      ref: "unselected-status-" + i,
                                      refInFor: true,
                                      staticClass: "pega-select-input",
                                      class: {
                                        "is-invalid-input":
                                          status.isInvalidName,
                                      },
                                      attrs: {
                                        "max-length": "5",
                                        type: "text",
                                        "data-test":
                                          "unselected-status-name-edit-" + i,
                                      },
                                      domProps: { value: status.editName },
                                      on: {
                                        keypress: function ($event) {
                                          return _vm.finishEdit($event, status)
                                        },
                                        keyup: function ($event) {
                                          return _vm.checkInvalidName(status)
                                        },
                                        blur: function ($event) {
                                          return _vm.finishEdit($event, status)
                                        },
                                        input: function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            status,
                                            "editName",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                !status.isEditing
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "boss-any-text",
                                        attrs: {
                                          "data-test":
                                            "unselected-status-any-" + i,
                                        },
                                      },
                                      [_vm._v("任意")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                status.isDeletable && !status.isEditing
                                  ? _c("span", {
                                      staticClass: "boss-icon-trash",
                                      attrs: {
                                        "data-test":
                                          "unselected-status-reset-" + i,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.removeStatus(status)
                                        },
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                status.isDeletable && !status.isEditing
                                  ? _c("span", {
                                      staticClass: "boss-icon-pencil",
                                      attrs: {
                                        "data-test":
                                          "unselected-status-edit-" + i,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.goEdit(
                                            status,
                                            "unselected-status-" + i
                                          )
                                        },
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                status.isInvalidName
                                  ? _c("validation-label", {
                                      attrs: {
                                        "data-test":
                                          "unselected-status-error-" + i,
                                        label: status.error,
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _vm.isDraggingStatus
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "boss-select-item pega-drop-area border-none-side",
                                attrs: { "data-test": "drop-area-status" },
                              },
                              [
                                _c("p", [
                                  _vm._v(
                                    "↑ この範囲に要素をドラッグしてください"
                                  ),
                                ]),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "boss-button-container" }, [
            _c(
              "button",
              {
                staticClass: "boss-button-default pega-button",
                attrs: {
                  "data-test": "statues-update",
                  disabled: _vm.hasEditingStatuses,
                },
                on: { click: _vm.registerStatues },
              },
              [_vm._v("\n          選考ステータスを更新する\n        ")]
            ),
          ]),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "boss-text" }, [
      _vm._v(
        "\n        ここで設定した選考フェーズで応募者管理ができ、応募者一覧や応募者詳細画面で参照できます。"
      ),
      _c("br"),
      _vm._v(
        "※選考フェーズを編集すると、既に選考中の応募者にも反映されますので、ご注意ください\n      "
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "boss-select-title" }, [
      _c("span", { staticClass: "boss-select-text" }, [
        _vm._v("設定されている選考フェーズ"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "boss-center-container" }, [
      _c("div", { staticClass: "boss-arrow" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "boss-select-title" }, [
      _c("span", { staticClass: "boss-select-text" }, [
        _vm._v("設定したい項目名を"),
        _c("br"),
        _vm._v("右枠から左枠にドラッグしてください。"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "boss-select-input-text" }, [
      _vm._v("\n                最大全角5文字まで入力可能です。"),
      _c("br"),
      _vm._v(
        "入力してEnterキーを押下すると、下に項目名が追加されます。\n              "
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "boss-text margin-bottom-1" }, [
      _vm._v(
        "\n        ここで設定した選考ステータスで応募者管理ができ、応募者一覧や応募者詳細画面で参照できます。"
      ),
      _c("br"),
      _vm._v(
        "※選考ステータスを編集すると、既に選考中の応募者にも反映されますので、ご注意ください\n      "
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "boss-select-title" }, [
      _c("span", { staticClass: "boss-select-text" }, [
        _vm._v("設定されている選考ステータス"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "boss-center-container" }, [
      _c("div", { staticClass: "boss-arrow" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "boss-select-title" }, [
      _c("span", { staticClass: "boss-select-text" }, [
        _vm._v("設定したい項目名を"),
        _c("br"),
        _vm._v("右枠から左枠にドラッグしてください。"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "boss-select-input-text" }, [
      _vm._v("\n                最大全角5文字まで入力可能です。"),
      _c("br"),
      _vm._v(
        "入力してEnterキーを押下すると、下に項目名が追加されます。\n              "
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }